import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { useEffect } from 'react';

import { useDefinitions } from '@/core/providers';

const APPLICATION_NAME = msg`Online application`;

export function usePageTitle(pageTitle: string) {
	const { _ } = useLingui();
	const { defs } = useDefinitions();

	const subtitle = defs?.customization?.company_name ? `${pageTitle} - ${defs.customization.company_name}` : pageTitle;

	useEffect(() => {
		document.title = `${subtitle} | ${_(APPLICATION_NAME)}`;

		return () => {
			document.title = _(APPLICATION_NAME);
		};
	}, [_, subtitle]);
}
